import { useMemo } from "react";
import { getJwtRoleSlug } from "../../../public/utils/jwtRole";
import { getStoredAuthRole } from "../../../public/utils/authSession";
import { useVisitorRolePermissions } from "../hooks/useVisitorRolePermissions";
import {
  buildVisitorPermissions,
  buildVisitorPermissionsForScreen,
} from "./visitorPermissions";

/** Current JWT role + visitor permissions from User builder (optional screen slug). */
export function useVisitorRole(screenSlug = null) {
  const roleSlug = useMemo(() => {
    if (typeof localStorage === "undefined") return "";
    return (
      getJwtRoleSlug(localStorage.getItem("jwt_token")) ||
      getStoredAuthRole() ||
      ""
    );
  }, []);

  const { permissions, loading: permLoading } = useVisitorRolePermissions(
    roleSlug,
    Boolean(roleSlug),
  );

  const perms = useMemo(() => {
    if (screenSlug) {
      return buildVisitorPermissionsForScreen(
        permissions,
        roleSlug,
        screenSlug,
      );
    }
    return buildVisitorPermissions(permissions, roleSlug);
  }, [permissions, roleSlug, screenSlug]);

  return {
    roleSlug,
    permissionsLoading: permLoading,
    isAdmin: perms.isAdmin,
    isOffice: perms.isOffice,
    isReceptionist: perms.isReceptionist,
    isOfficePanel:
      (perms.isOffice || perms.isReceptionist) &&
      (perms.canView || perms.canCreate),
    canView: perms.canView,
    canCreate: perms.canCreate,
    canFullEdit: perms.canFullEdit,
    canLimitedEdit: perms.canLimitedEdit,
    canEdit: perms.canEdit,
    canExit: perms.canExit,
    canSlip: perms.canSlip,
    canDelete: perms.canDelete,
    canManageMasters: perms.canManageMasters,
    canDeleteMasters: perms.canDeleteMasters,
    canExport: perms.canExport,
  };
}
